import React from "react";
import { useSubscription } from "../../hooks/useSubscription";

/**
 * Component to display subscription warning banner
 * Should be displayed when subscription is inactive/expired
 */
const SubscriptionWarning = ({ className = "" }) => {
  const {
    isActive,
    warningMessage,
    hasSubscription,
    isSupportSession,
  } = useSubscription();

  // Regular staff: only warn when subscription exists but is not active.
  // Support sessions: show advisory when coop plan is missing/expired (access still allowed).
  if (isSupportSession) {
    if (!warningMessage) return null;
  } else if (!hasSubscription || isActive) {
    return null;
  }

  return (
    <div
      className={`bg-[#FFF4E5] border-l-4 border-[#FFA500] p-4 mb-4 ${className}`}
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-[#FFA500]"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm font-medium text-[#856404]">
            {warningMessage}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionWarning;

